import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=68108984&scoped=true&"
var script = {}
import style0 from "./rule.vue?vue&type=style&index=0&id=68108984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68108984",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68108984')) {
      api.createRecord('68108984', component.options)
    } else {
      api.reload('68108984', component.options)
    }
    module.hot.accept("./rule.vue?vue&type=template&id=68108984&scoped=true&", function () {
      api.rerender('68108984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/register/rule.vue"
export default component.exports